import { PresentationChartBarIcon } from '@heroicons/react/24/outline';
export const PresentationChartIcon = PresentationChartBarIcon;
